import React, { useState } from 'react';
import { HeroSection } from '../../components/HeroSection';
import { Button } from '../../components/ui/Button';
import { ChevronDown, ChevronUp, FileText, Image, Mic, DollarSign } from 'lucide-react';
export function Contribute() {
  const [expandedSection, setExpandedSection] = useState<number | null>(0);
  const guidelines = [{
    icon: <FileText className="h-8 w-8" data-id="element-559" />,
    title: "What We're Looking For",
    content: <div className="space-y-4" data-id="element-560">
          <p className="text-gray-700" data-id="element-561">
            We publish essays, reporting, poetry, visual art, and hybrid forms
            that center fat liberation and justice.
          </p>
          <div className="bg-brand-orange/5 p-4 border-l-4 border-brand-orange" data-id="element-562">
            <h4 className="font-bold mb-2" data-id="element-563">We want work that:</h4>
            <ul className="space-y-2 text-sm" data-id="element-564">
              <li className="flex items-start" data-id="element-565">
                <span className="text-brand-orange mr-2" data-id="element-566">✓</span>
                <span data-id="element-567">Challenges dominant narratives about fat bodies</span>
              </li>
              <li className="flex items-start" data-id="element-568">
                <span className="text-brand-orange mr-2" data-id="element-569">✓</span>
                <span data-id="element-570">Centers fat people's lived experiences</span>
              </li>
              <li className="flex items-start" data-id="element-571">
                <span className="text-brand-orange mr-2" data-id="element-572">✓</span>
                <span data-id="element-573">Engages with theory, history, or political analysis</span>
              </li>
              <li className="flex items-start" data-id="element-574">
                <span className="text-brand-orange mr-2" data-id="element-575">✓</span>
                <span data-id="element-576">Takes risks formally or conceptually</span>
              </li>
              <li className="flex items-start" data-id="element-577">
                <span className="text-brand-orange mr-2" data-id="element-578">✓</span>
                <span data-id="element-579">Shows craft and attention to language</span>
              </li>
            </ul>
          </div>
          <div className="bg-gray-50 p-4 border-l-4 border-gray-300" data-id="element-580">
            <h4 className="font-bold mb-2" data-id="element-581">We're not looking for:</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-582">
              <li className="flex items-start" data-id="element-583">
                <span className="mr-2" data-id="element-584">✗</span>
                <span data-id="element-585">101-level explainers for thin audiences</span>
              </li>
              <li className="flex items-start" data-id="element-586">
                <span className="mr-2" data-id="element-587">✗</span>
                <span data-id="element-588">"Body positivity" or self-love narratives</span>
              </li>
              <li className="flex items-start" data-id="element-589">
                <span className="mr-2" data-id="element-590">✗</span>
                <span data-id="element-591">Work by thin people about their "body image"</span>
              </li>
              <li className="flex items-start" data-id="element-592">
                <span className="mr-2" data-id="element-593">✗</span>
                <span data-id="element-594">Anything that centers weight loss or diet culture</span>
              </li>
            </ul>
          </div>
        </div>
  }, {
    icon: <Image className="h-8 w-8" data-id="element-595" />,
    title: 'Submission Guidelines',
    content: <div className="space-y-4" data-id="element-596">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-597">
            <div data-id="element-598">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-599">
                Essays & Reporting
              </h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-600">
                <li data-id="element-601">
                  <strong data-id="element-602">Length:</strong> 1,500-5,000 words
                </li>
                <li data-id="element-603">
                  <strong data-id="element-604">Format:</strong> .doc or .docx
                </li>
                <li data-id="element-605">
                  <strong data-id="element-606">Include:</strong> Brief bio (50-100 words)
                </li>
                <li data-id="element-607">
                  <strong data-id="element-608">Response time:</strong> 4-6 weeks
                </li>
              </ul>
            </div>
            <div data-id="element-609">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-610">Poetry</h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-611">
                <li data-id="element-612">
                  <strong data-id="element-613">Length:</strong> Up to 5 poems
                </li>
                <li data-id="element-614">
                  <strong data-id="element-615">Format:</strong> .doc or .docx
                </li>
                <li data-id="element-616">
                  <strong data-id="element-617">Include:</strong> Brief bio (50-100 words)
                </li>
                <li data-id="element-618">
                  <strong data-id="element-619">Response time:</strong> 6-8 weeks
                </li>
              </ul>
            </div>
            <div data-id="element-620">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-621">Visual Work</h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-622">
                <li data-id="element-623">
                  <strong data-id="element-624">Format:</strong> High-res JPG or PNG
                </li>
                <li data-id="element-625">
                  <strong data-id="element-626">Include:</strong> Artist statement (200-300 words)
                </li>
                <li data-id="element-627">
                  <strong data-id="element-628">Series:</strong> 5-10 images preferred
                </li>
                <li data-id="element-629">
                  <strong data-id="element-630">Response time:</strong> 4-6 weeks
                </li>
              </ul>
            </div>
            <div data-id="element-631">
              <h4 className="font-bold text-brand-orange mb-3" data-id="element-632">
                Hybrid/Experimental
              </h4>
              <ul className="space-y-2 text-sm text-gray-700" data-id="element-633">
                <li data-id="element-634">
                  <strong data-id="element-635">Format:</strong> Varies—contact us first
                </li>
                <li data-id="element-636">
                  <strong data-id="element-637">Include:</strong> Description of form/concept
                </li>
                <li data-id="element-638">
                  <strong data-id="element-639">Examples:</strong> Comics, audio, video essays
                </li>
                <li data-id="element-640">
                  <strong data-id="element-641">Response time:</strong> 6-8 weeks
                </li>
              </ul>
            </div>
          </div>
        </div>
  }, {
    icon: <DollarSign className="h-8 w-8" data-id="element-642" />,
    title: 'Payment & Rights',
    content: <div className="space-y-4" data-id="element-643">
          <div className="bg-brand-orange/10 p-6 border-2 border-brand-orange" data-id="element-644">
            <h4 className="font-bold text-lg mb-3" data-id="element-645">We Pay Our Contributors</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm" data-id="element-646">
              <div data-id="element-647">
                <p className="font-bold text-brand-orange mb-1" data-id="element-648">
                  Essays & Reporting
                </p>
                <p data-id="element-649">$0.25/word (minimum $375)</p>
              </div>
              <div data-id="element-650">
                <p className="font-bold text-brand-orange mb-1" data-id="element-651">Poetry</p>
                <p data-id="element-652">$100 per poem</p>
              </div>
              <div data-id="element-653">
                <p className="font-bold text-brand-orange mb-1" data-id="element-654">Visual Work</p>
                <p data-id="element-655">$200-500 depending on scope</p>
              </div>
              <div data-id="element-656">
                <p className="font-bold text-brand-orange mb-1" data-id="element-657">Hybrid Forms</p>
                <p data-id="element-658">Negotiated based on project</p>
              </div>
            </div>
          </div>
          <div className="prose prose-sm" data-id="element-659">
            <h4 className="font-bold" data-id="element-660">Rights & Licensing</h4>
            <p className="text-gray-700" data-id="element-661">
              We purchase first serial rights. You retain copyright and can
              republish your work elsewhere after 90 days. We ask that you
              credit ReGrowth as the original publisher.
            </p>
            <h4 className="font-bold mt-4" data-id="element-662">Payment Timeline</h4>
            <p className="text-gray-700" data-id="element-663">
              Payment is issued within 30 days of publication via PayPal, Venmo,
              or check. International contributors: we can accommodate various
              payment methods.
            </p>
          </div>
        </div>
  }, {
    icon: <Mic className="h-8 w-8" data-id="element-664" />,
    title: 'Editorial Process',
    content: <div className="space-y-4" data-id="element-665">
          <p className="text-gray-700" data-id="element-666">
            We believe in collaborative editing. If we accept your piece, here's
            what to expect:
          </p>
          <div className="space-y-6" data-id="element-667">
            <div className="flex gap-4" data-id="element-668">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-669">
                1
              </div>
              <div data-id="element-670">
                <h4 className="font-bold mb-1" data-id="element-671">Acceptance & Contract</h4>
                <p className="text-sm text-gray-700" data-id="element-672">
                  We'll send you a contract outlining payment, timeline, and
                  rights. Sign and return within 2 weeks.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-673">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-674">
                2
              </div>
              <div data-id="element-675">
                <h4 className="font-bold mb-1" data-id="element-676">Developmental Edit</h4>
                <p className="text-sm text-gray-700" data-id="element-677">
                  Your editor will send big-picture feedback on structure,
                  argument, and development. You'll have 2-3 weeks to revise.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-678">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-679">
                3
              </div>
              <div data-id="element-680">
                <h4 className="font-bold mb-1" data-id="element-681">Line Edit</h4>
                <p className="text-sm text-gray-700" data-id="element-682">
                  We'll work on language, clarity, and flow. This is a
                  collaborative process—we'll discuss changes with you.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-683">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-684">
                4
              </div>
              <div data-id="element-685">
                <h4 className="font-bold mb-1" data-id="element-686">Copyedit & Fact-Check</h4>
                <p className="text-sm text-gray-700" data-id="element-687">
                  Our copyeditor will check grammar, style, and facts. You'll
                  review and approve final changes.
                </p>
              </div>
            </div>
            <div className="flex gap-4" data-id="element-688">
              <div className="w-12 h-12 rounded-full bg-brand-orange text-white flex items-center justify-center font-black flex-shrink-0" data-id="element-689">
                5
              </div>
              <div data-id="element-690">
                <h4 className="font-bold mb-1" data-id="element-691">Publication</h4>
                <p className="text-sm text-gray-700" data-id="element-692">
                  We'll schedule your piece and promote it across our channels.
                  You'll receive payment within 30 days.
                </p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-4 border-l-4 border-brand-orange mt-6" data-id="element-693">
            <p className="text-sm text-gray-700" data-id="element-694">
              <strong data-id="element-695">Timeline:</strong> From acceptance to publication
              typically takes 2-4 months, depending on the piece and our
              editorial calendar.
            </p>
          </div>
        </div>
  }];
  return <div className="min-h-screen bg-brand-cream" data-id="element-696">
      <HeroSection title="Contribute / Write With Us" subtitle="We're always looking for fat writers, artists, and thinkers to join our pages." tag="The Digital Publication" bgColor="orange" data-id="element-697" />

      {/* Introduction */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-698">
        <div className="prose prose-lg" data-id="element-699">
          <p className="text-xl text-gray-700 leading-relaxed" data-id="element-700">
            The Digital Publication exists because of{' '}
            <strong className="text-brand-orange" data-id="element-701">
              fat people's creativity, intellect, and courage
            </strong>
            . We want to publish your work—whether you're an established writer
            or this is your first time submitting.
          </p>
          <p className="text-lg text-gray-600 mt-4" data-id="element-702">
            We especially encourage submissions from fat Black, Indigenous,
            disabled, trans, and working-class writers.
          </p>
        </div>
      </section>

      {/* Accordion Guidelines */}
      <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-703">
        <div className="space-y-4" data-id="element-704">
          {guidelines.map((section, index) => <div key={index} className="border-2 border-brand-black bg-white" data-id="element-705">
              <button onClick={() => setExpandedSection(expandedSection === index ? null : index)} className="w-full p-6 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-706">
                <div className="flex items-center gap-4" data-id="element-707">
                  <div className="text-brand-orange" data-id="element-708">{section.icon}</div>
                  <h3 className="text-xl font-black uppercase text-brand-black text-left" data-id="element-709">
                    {section.title}
                  </h3>
                </div>
                {expandedSection === index ? <ChevronUp className="h-6 w-6 text-brand-orange flex-shrink-0" data-id="element-710" /> : <ChevronDown className="h-6 w-6 text-gray-400 flex-shrink-0" data-id="element-711" />}
              </button>

              {expandedSection === index && <div className="p-6 pt-0 border-t-2 border-gray-100" data-id="element-712">
                  {section.content}
                </div>}
            </div>)}
        </div>
      </section>

      {/* Submit CTA */}
      <section className="py-20 bg-brand-orange text-white" data-id="element-713">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-714">
          <h2 className="text-3xl font-black uppercase mb-6" data-id="element-715">
            Ready to Submit?
          </h2>
          <p className="text-xl mb-8 opacity-90" data-id="element-716">
            Send your work to submissions@regrowth.com with "SUBMISSION: [Type]"
            in the subject line.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-717">
            <Button color="white" size="lg" data-id="element-718">
              Email Your Submission
            </Button>
            <Button variant="outline" color="white" size="lg" data-id="element-719">
              Questions? Contact Us
            </Button>
          </div>
          <p className="text-sm mt-8 opacity-75" data-id="element-720">
            We read submissions year-round. No simultaneous submissions please.
          </p>
        </div>
      </section>
    </div>;
}